import React from 'react'
import { BlogContext, ContextProps } from './BlogBink'

const useBlogBink = () => {
  const context = React.useContext(BlogContext)

  return context as ContextProps
}

export default useBlogBink
